<template>
  <thead>
    <tr>
      <slot />
    </tr>
  </thead>
</template>
